import {
    BLOCK_HEADING_1,
    BLOCK_HEADING_2,
    BLOCK_HEADING_3,
    BLOCK_PARAGRAPH,
} from '@gitbook/doc-core';
import type { Block, Change } from '@gitbook/slate';
import type { Plugin } from '@gitbook/slate-react';

import { type BlockType, paragraphToBlock } from '../paragraph';

export const plugin: Plugin = {
    onKeyDown,
};

/**
 * Handle key down events for heading blocks.
 */
function onKeyDown(event: KeyboardEvent, change: Change): Change | undefined {
    if (isTextLevelShortCut(event)) {
        return onTextBlockLevelChange(event, change);
    }
}

/**
 * Using keyboard shortcuts to change the text block type.
 */
function onTextBlockLevelChange(event: KeyboardEvent, change: Change): Change | undefined {
    const { value } = change;
    const digit = event.code.at(-1);

    if (!digit) {
        return undefined;
    }

    event.preventDefault();

    const target = BLOCK_TEXT[digit];

    const block = value.startBlock as Block | null;
    if (!block) {
        return undefined;
    }

    paragraphToBlock(change, block, target);

    return change;
}
function isTextLevelShortCut(event: KeyboardEvent): boolean {
    // Cmd on Mac, Ctrl on Windows
    const mod = event.metaKey || event.ctrlKey;
    return mod && event.altKey && ['Digit0', 'Digit1', 'Digit2', 'Digit3'].includes(event.code);
}
export const BLOCK_TEXT: BlockType[] = [
    BLOCK_PARAGRAPH,
    BLOCK_HEADING_1,
    BLOCK_HEADING_2,
    BLOCK_HEADING_3,
];
